import tick from '../../../styles/assets/toast/green_tick.png';
import alert from '../../../styles/assets/toast/red_alert.png';
import styled from 'styled-components';
import React, { useEffect, useState } from "react";

const Title = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #FFFFFF;
`;

/* A functional component that takes in a prop called message and returns a div with a span and an
image. */
const Transaction = (props: any) => {
  
    if(props.type === 'pending') {
      return ( 
        <div style={{flexDirection:'row',  display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}>
          <Title>Transfer submitted, Processing...</Title>
        </div>
      );
    }
    if(props.type === 'success') {
      return ( 
        <div style={{flexDirection:'row',  display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}>
          <img style={{width: 24, height: 24}} src={tick} />
          <Title style={{marginLeft: 8}}>Transfer successfully completed</Title>
        </div>
      );
    } 
    if(props.type === 'failure') {
      return ( 
        <div style={{flexDirection:'row',  display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}>
          <img style={{width: 24, height: 24}} src={alert} />
          <Title style={{marginLeft: 8}}>Transfer failed</Title>
        </div>
      );
    }
    return (<></>)   
  
}

export default Transaction;